import { apiService } from "./api";
import { API_CONFIG } from "../config/api";
import { Supplier, CreateSupplierRequest, SearchParams } from "../types";

export class SupplierService {
    // Suppliers
    async getSuppliers(params?: SearchParams): Promise<Supplier[]> {
        const queryParams = new URLSearchParams();
        if (params?.skip) queryParams.append("skip", params.skip.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        if (params?.active_only !== undefined)
            queryParams.append("active_only", params.active_only.toString());
        if (params?.search) queryParams.append("search", params.search);

        const url = `${
            API_CONFIG.ENDPOINTS.SUPPLIERS.BASE
        }?${queryParams.toString()}`;
        return apiService.get<Supplier[]>(url);
    }

    async getSupplierById(id: string): Promise<Supplier> {
        return apiService.get<Supplier>(
            `${API_CONFIG.ENDPOINTS.SUPPLIERS.BASE}/${id}`
        );
    }

    async createSupplier(data: CreateSupplierRequest): Promise<Supplier> {
        return apiService.post<Supplier>(
            API_CONFIG.ENDPOINTS.SUPPLIERS.BASE,
            data
        );
    }

    async updateSupplier(
        id: string,
        data: Partial<CreateSupplierRequest>
    ): Promise<Supplier> {
        return apiService.put<Supplier>(
            `${API_CONFIG.ENDPOINTS.SUPPLIERS.BASE}/${id}`,
            data
        );
    }

    async deleteSupplier(id: string): Promise<void> {
        return apiService.delete<void>(
            `${API_CONFIG.ENDPOINTS.SUPPLIERS.BASE}/${id}`
        );
    }

    async searchSuppliers(params: {
        q: string;
        skip?: number;
        limit?: number;
    }): Promise<Supplier[]> {
        const queryParams = new URLSearchParams();
        queryParams.append("q", params.q);
        if (params.skip) queryParams.append("skip", params.skip.toString());
        if (params.limit) queryParams.append("limit", params.limit.toString());

        const url = `${
            API_CONFIG.ENDPOINTS.SUPPLIERS.SEARCH
        }?${queryParams.toString()}`;
        return apiService.get<Supplier[]>(url);
    }
}

export const supplierService = new SupplierService();
